import { Channel } from "./v1";
import { ChannelV2 } from "./v2";

export const getChannelEnum = (version?: string) => {
	if (version == null) return Channel;
	return ChannelV2;
};
